import React from "react";
import {
  Avatar,
  Box,
  Divider,
  IconButton,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import { ExitToApp, Person } from "@mui/icons-material";
import theme from "../../../theme";
import { useDispatch, useSelector } from "../../../store";
import { logout } from "../../../slices/auth";
import { useNavigate } from "react-router-dom";
import CompanyLogo from "../../base/CompanyLogo";

interface Props {
  handleClose: () => void;
}

const ProfileMenuView: React.FC<Props> = (props) => {
  const { handleClose } = props;
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { loggedInUser, userCompany } = useSelector((store) => store.auth);

  const menuItems = [
    {
      label: "Account",
      icon: <Person />,
      function: () => navigate(`/account`),
      authorized: true,
    },
    {
      label: "Logout",
      icon: <ExitToApp />,
      function: () => {
        dispatch(logout());
      },
      authorized: true,
    },
  ];

  return (
    <Box width={250} display="flex" role="presentation" onClick={handleClose}>
      <List sx={{ width: "100%" }}>
        <ListItem disablePadding>
          <ListItemText
            primary={`${loggedInUser?.firstName} ${loggedInUser?.lastName}`}
            primaryTypographyProps={{
              fontSize: 20,
              color: "primary",
              justifySelf: "center",
            }}
          />
        </ListItem>
        {userCompany && (
          <>
            <Box>
              <ListItem>
                <ListItemIcon sx={{ paddingX: 2 }}>
                  <CompanyLogo company={userCompany} size="50px" />
                </ListItemIcon>
                <ListItemText
                  primary={userCompany?.companyName}
                  primaryTypographyProps={{
                    fontSize: 14,
                    fontWeight: "bold",
                    color: "primary",
                  }}
                />
              </ListItem>
              <Divider sx={{ margin: 1 }} />
            </Box>
          </>
        )}
        {menuItems
          .filter((x) => !!x.authorized)
          .map((item) => (
            <Box key={item.label}>
              <ListItem disablePadding>
                <ListItemButton
                  onClick={item.function}
                  sx={{
                    "&:hover, &:focus": {
                      "& svg:first-of-type": {
                        transition: "0.5s",
                        transform: "rotate(-180deg)",
                      },
                    },
                  }}
                >
                  <ListItemIcon sx={{ paddingX: 2 }}>
                    <Avatar
                      sx={{
                        backgroundColor: theme.palette.primary.main,
                        width: "35px",
                        height: "35px",
                        color: "#fff",
                      }}
                    >
                      <IconButton color="inherit">{item.icon}</IconButton>
                    </Avatar>
                  </ListItemIcon>
                  <ListItemText
                    primary={item.label}
                    primaryTypographyProps={{
                      fontSize: 16,
                      fontWeight: "light",
                      color: "primary",
                    }}
                  />
                </ListItemButton>
              </ListItem>
            </Box>
          ))}
      </List>
    </Box>
  );
};

export default ProfileMenuView;
